import { compose, replace, startCase, toLower } from 'lodash/fp';

export const toUrlSlug = (text: string) =>
    text
        ? text
              .trim()
              .toLowerCase()
              .replace(/[^\w ]+/g, '')
              .replace(/ +/g, '-')
        : text;

export const toFriendlyName = compose(startCase, replace('_', ' '), toLower);
